var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m13.414 12 6.364 6.364-1.414 1.414L12 13.414l-6.364 6.364-1.414-1.414L10.586 12 4.222 5.636l1.414-1.414L12 10.586l6.364-6.364 1.414 1.414L13.414 12Z",
  fill: "#DFDFDF"
})));

export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy40MTQyIDEyTDE5Ljc3ODIgMTguMzY0TDE4LjM2NCAxOS43NzgyTDEyIDEzLjQxNDNMNS42MzYwNCAxOS43NzgyTDQuMjIxODMgMTguMzY0TDEwLjU4NTggMTJMNC4yMjE4MyA1LjYzNjA4TDUuNjM2MDQgNC4yMjE4N0wxMiAxMC41ODU4TDE4LjM2NCA0LjIyMTg3TDE5Ljc3ODIgNS42MzYwOEwxMy40MTQyIDEyWiIgZmlsbD0iI0RGREZERiIvPgo8L3N2Zz4K";